import {
  LucideArmchair,
  LucideArrowLeft,
  LucideArrowRight,
  LucideBus,
  LucideCalendar,
  LucideChevronDown,
  LucideChevronRight,
  LucideCircleCheck,
  LucideClock,
  LucideCreditCard,
  LucideDownload,
  LucideInfo,
  LucideLoaderCircle,
  LucideLock,
  LucideMail,
  LucideMapPin,
  LucideMenu,
  LucideNewspaper,
  LucidePhone,
  LucidePrinter,
  LucideQrCode,
  LucideSearch,
  LucideShield,
  LucideSmartphone,
  LucideStar,
  LucideTag,
  LucideTicket,
  LucideTrendingUp,
  LucideUser,
  LucideUsers,
  LucideWallet,
  LucideX,
  provideLucideIcons,
} from '@lucide/angular';

export const lucideIconsProvider = provideLucideIcons(
  LucideBus,
  LucideMapPin,
  LucideSearch,
  LucideCalendar,
  LucideUsers,
  LucideChevronRight,
  LucideChevronDown,
  LucidePhone,
  LucideArrowRight,
  LucideArrowLeft,
  LucideNewspaper,
  LucideTicket,
  LucideShield,
  LucideStar,
  LucideClock,
  LucideCircleCheck,
  LucideTrendingUp,
  LucideMail,
  LucideMenu,
  LucideSmartphone,
  LucidePrinter,
  LucideDownload,
  LucideCreditCard,
  LucideTag,
  LucideWallet,
  LucideLock,
  LucideQrCode,
  LucideInfo,
  LucideX,
  LucideLoaderCircle,
  LucideArmchair,
  LucideUser,
);
